import { useEffect } from 'react'
import { notification } from 'sounds/index'
import { WebsocketEvent } from 'entities/WebSocket'
import { checkMicrophone, type IResponseCallQueueParticipant } from 'entities/Call'
import { useEntitiesContext } from 'entities/EntitiesExport'
import type { CallPopUpGlobalStore } from 'widgets/CallPopUp'

const notificationAudio = notification.getAudio('notificationCallQueue')

export const useEventCallQueueParticipantJoin = (callPopUpGlobalStore: CallPopUpGlobalStore) => {
  const { inboxesStore, usersStore, websocket } = useEntitiesContext()
  const handler = async (data: IResponseCallQueueParticipant) => {
    const enable_microphone = await checkMicrophone()
    const isAwait = usersStore.isAwayStatus

    if (!enable_microphone) return

    if (!isAwait) {
      notificationAudio.play()
    }
    inboxesStore.channelsInboxes.subscribeChannel(data.team.id)
    callPopUpGlobalStore.addQueueItem(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallQueueParticipantJoin, handler), [])
}
